import * as React from "react";
import { useState } from "react";
import moment from "moment";
import { BootstrapModalForm } from "components/bootstrap";
import { TimeUnitInput } from "components/common";
import { extractDurationAndUnit } from "components/common/TimeUnitInput";
import UserNotification from "util/UserNotification";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { setWatchlistDefaultTtl } from "watchlist/hooks/useWatchlistsV2";
const TTL_UNITS = ["DAYS", "HOURS", "MINUTES", "SECONDS"];
const DEFAULT_TTL_SECONDS = 24 * 60 * 60;
const SetDefaultTtlModal = ({ watchlistId, watchlistName, currentTtlSeconds = 0, onClose, onUpdated }) => {
  const hasTtl = currentTtlSeconds > 0;
  const initial = extractDurationAndUnit((hasTtl ? currentTtlSeconds : DEFAULT_TTL_SECONDS) * 1e3, TTL_UNITS);
  const [enabled, setEnabled] = useState(hasTtl);
  const [duration, setDuration] = useState(initial.duration);
  const [unit, setUnit] = useState(initial.unit);
  const [submitting, setSubmitting] = useState(false);
  const sendTelemetry = useSendTelemetry();
  const handleChange = (nextValue, nextUnit, checked) => {
    setEnabled(checked);
    setDuration(nextValue);
    setUnit(nextUnit);
  };
  const handleSubmit = () => {
    const seconds = enabled ? Math.round(moment.duration(Math.max(duration, 1), unit).asSeconds()) : 0;
    if (!Number.isFinite(seconds) || seconds < 0) {
      UserNotification.error("TTL must be a non-negative duration.");
      return;
    }
    setSubmitting(true);
    setWatchlistDefaultTtl(watchlistId, seconds).then(() => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.WATCHLIST.DEFAULT_TTL_SET, {
        app_section: "watchlist-details",
        app_action_value: "watchlist-default-ttl-set",
        event_details: { watchlist_name: watchlistName, ttl_seconds: seconds }
      });
      UserNotification.success(
        seconds > 0 ? `Set default TTL for "${watchlistName}" to ${seconds} second${seconds === 1 ? "" : "s"}.` : `Default TTL for "${watchlistName}" cleared; new entries will not expire by default.`
      );
      onUpdated();
      onClose();
    }).catch((error) => UserNotification.error(`Setting default TTL failed: ${error}`)).finally(() => setSubmitting(false));
  };
  return /* @__PURE__ */ React.createElement(
    BootstrapModalForm,
    {
      show: true,
      title: `Set default TTL for "${watchlistName}"`,
      onSubmitForm: handleSubmit,
      onCancel: onClose,
      submitButtonText: submitting ? "Saving\u2026" : "Save",
      submitButtonDisabled: submitting
    },
    /* @__PURE__ */ React.createElement(
      TimeUnitInput,
      {
        label: "Default TTL for new entries",
        help: "Applied to newly added entries that don't specify their own TTL. Uncheck for no expiry.",
        update: handleChange,
        value: duration,
        unit,
        units: TTL_UNITS,
        enabled
      }
    )
  );
};
export default SetDefaultTtlModal;
